module.exports = __webpack_public_path__ + "img/1.5f8f75e8.png";